<template>
  <div class="text-box">
    <h2 class="m-b-20 section-title">{{ $t('Select your payment terms') }}</h2>
    <div class="card">
      <div class="row">
        <!-- INCOTERMS -->
        <div :class="classIncoterms" v-if="showIncoterms">
          <InputSelect
            :label="$t('Incoterms')"
            v-model="value.goods_incoterm"
            @change="checkDutyAndCarrierNo"
            :options="incotermsOptions"
          />
        </div>
        <!-- DUTY PAID BY -->
        <div
          v-if="value.goods_incoterm === 'DDP' && showIncoterms"
          :class="classDutyPaidBy">
          <InputSelect
            :label="$t('duty_paid_by')"
            v-model="value.duty_paid_by"
            @change="checkCarrierNo"
            :options="dutyPaidByOptions"
          />
        </div>
        <!-- CARRIER NUMBER -->
        <div class="col-xs-4" v-if="(value.duty_paid_by === 3 || value.duty_paid_by === 2) && showIncoterms && value.goods_incoterm === 'DDP' ">
          <InputText
            v-model="value.duty_payer_account_no"
            :label="$t('Carrier account no.')"
          />
        </div>
        <!-- CARRIER ADDRESS -->
        <div class="col-xs-12" v-if="value.duty_paid_by === 3 && showIncoterms">
          <AddressPicker
            class="m-b-input"
            :label="$t('address_1')"
            placeholder="Search address"
            @addressSelected="changeAddress('customs', $event)"
            v-model="value.customsAddress"
          />
          <div class="row m-b-input">
            <div class="col-xs-3">
              <InputText
                v-model="value.customsAddressData.vat"
                label="EORI"
              />
            </div>
            <div class="col-xs-3">
              <InputText
                v-model="value.customsAddressData.company"
                :label="$t('company')"
              />
            </div>
            <div class="col-xs-3">
              <InputText
                v-model="value.customsAddressData.attention"
                :label="$t('name')"
              />
            </div>
            <div class="col-xs-3">
              <InputText
                v-model="value.customsAddressData.reference"
                :label="$t('reference')"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-6">
              <PhoneSelect v-model="value.customsAddressData.phone" />
            </div>
            <div class="col-xs-6">
              <InputText
                v-model="value.customsAddressData.email"
                label="Email"
              />
            </div>
          </div>
        </div>
        <div class="col-xs-12" v-if="value.duty_paid_by === 3 && showIncoterms && showFreightBy">
          <div class="separator"></div>
        </div>
        <!-- FREIGHT PAID BY -->
        <div
          v-if="showFreightBy"
          :class="classFreightBy">
          <InputSelect
            v-if="showFreightBy"
            :label="$t('freight_paid_by')"
            v-model="value.freight_paid_by"
            @change="checkFreightandCustomerInfo"
            :options="freightPaidByOptions"
          />
        </div>
        <!-- FREIGHT NUMBER -->
        <div
          v-if="value.freight_paid_by === 2 || value.freight_paid_by === 3"
          class="col-xs-6"
          :class="value.freight_paid_by === 3 ? 'm-b-20' : ''">
          <InputText
            v-model="value.freight_payer_account_no"
            :label="$t('Freight Carrier account no.')"
          />
        </div>
        <div
          v-if="value.freight_paid_by === 4"
          class="col-xs-6">
          <InputSelect
            :label="$t('LBL_PAYERS')"
            v-model="value.freight_payer_id"
            :options="get_payer_select"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import mixin from '@/mixins/mixins.js';
import InputText from "@/components/elements/inputs/text.vue";
import InputSelect from "@/components/elements/inputs/select.vue";
import AddressPicker from "@/components/global/addressPicker/index.vue";
import PhoneSelect from "@/components/elements/inputs/phone.vue";
import {mapGetters} from "vuex";

export default {
  name: 'payment-terms',
  mixins: [mixin],
  components: {
    InputSelect,
    InputText,
    AddressPicker,
    PhoneSelect,
  },
  props: {
    showFreightBy: {
      type: Boolean,
      default: true,
    },
    showCustoms: {
      type: Boolean,
      default: true,
    },
    showIncoterms: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default: () => {
        return{
          customsAddress: {
            address_1: '',
            address_2: '',
            country_id: '',
            post_code: '',
            city: '',
            state: '',
          },
          customsAddressData: {
            company: '',
            attention: '',
            email: '',
            reference: '',
            phone: {
              number: '',
              country: '',
            },
          },
          goods_incoterm: '',
          duty_paid_by: '',
          duty_payer_account_no: '',
          freight_paid_by: '',
          freight_payer_account_no: '',
        }
      },
    },
  },
  data() {
    return{
      incotermServices: [],
      incotermServiceId: '',
      reciverPayId: '',
      incotermsOptions: [
        { text: `${this.$t('DAP')}`, value: 'DAP'},
        { text: `${this.$t('DDP')}`, value: 'DDP'},
        { text: `${this.$t('EXW')}`, value: 'EXW'},
        { text: `${this.$t('FCA')}`, value: 'FCA'},
        { text: `${this.$t('CPT')}`, value: 'CPT'},
        { text: `${this.$t('CIP')}`, value: 'CIP'},
        { text: `${this.$t('DPU')}`, value: 'DPU'},
      ],
      dutyPaidByOptions: [
        { text: `${this.$t('Seller')}`, value: 1},
        { text: `${this.$t('Reciever')}`, value: 2},
        { text: `${this.$t('Third party')}`, value: 3},
      ]
    };
  },
  computed: {
    freightPaidByOptions() {
      const options = [];
      options.push({ text: `${this.$t('Seller')}`, value: 1})
      if (this.get_payers.items.length > 0) {
        options.push({ text: `${this.$t('LBL_PAYER_LIST')}`, value: 4})
      }
      options.push({ text: `${this.$t('Other')}`, value: 2})

      return options
    },
    classIncoterms() {
      if(this.showFreightBy) {
        if(this.value.duty_paid_by === 3 || this.value.duty_paid_by === 2){
          return 'col-xs-4 m-b-20';
        } else if(this.value.goods_incoterm == 'DDP') {
          return 'col-xs-6 m-b-20';
        } else if(this.value.freight_paid_by === 1) {
          return 'col-xs-6';
        } else {
          if(this.value.goods_incoterm !== 'DDP' && this.value.freight_paid_by === 1) {
            return 'col-xs-6 m-b-20';
          } else {
            return 'col-xs-12 m-b-20';
          }
        }
      } else {
        if(this.value.duty_paid_by === 3 || this.value.duty_paid_by === 2){
          return this.value.duty_paid_by === 3 ? 'col-xs-4 m-b-20' : 'col-xs-4';
        } else if(this.value.goods_incoterm == 'DDP') {
          return 'col-xs-6';
        } else {
          return 'col-xs-12'
        }
      }
    },
    classDutyPaidBy() {
      if(this.showFreightBy) {
        if(this.value.duty_paid_by === 3 || this.value.duty_paid_by === 2) {
          return 'col-xs-4 m-b-20';
        } else {
          return 'col-xs-6 m-b-20';
        }
      } else {
        if(this.value.duty_paid_by === 3 || this.value.duty_paid_by === 2) {
          return 'col-xs-4';
        } else {
          return 'col-xs-6';
        }
      }
    },
    classFreightBy() {
      if(this.showIncoterms) {
        if(this.value.goods_incoterm !== 'DDP') {
          if(this.value.freight_paid_by === 1){
            return 'col-xs-6';
          } else {
            return 'col-xs-6 m-b-20';
          }
        } else if (this.value.goods_incoterm === 'DDP') {
          if( this.value.freight_paid_by === 1 ) {
            return 'col-xs-12';
          } else {
            return 'col-xs-6';
          }
        }
      } else {
        if(this.value.freight_paid_by === 1){
          return 'col-xs-12';
        } else {
          return 'col-xs-6';
        }
      }
    },
    ...mapGetters([
      'get_payers',
      'get_payer_select'
    ])
  },
  created() {

    this.$store.dispatch('GET_PAYERS_OPTIONS');

    this.$store.dispatch('GET_PAYMENT_TERMS', {
      category: '23', // ovo je zakucana kategorija na incoterm
      incoterms: 'DDP', // ovo je zakucano na DDP
    }).then((res) => {
      this.incotermServiceId = res.data.data.id;
    });

    this.$store.dispatch('GET_PAYMENT_TERMS', {
      category: '14', // ovo je zakucana kategorija na get paiment terms
      incoterms: null,
    }).then((res) => {
      this.reciverPayId = res.data.data.id;
    });

    if (this.value.goods_incoterm !== 'DDP') {
      this.value.duty_paid_by = null;
    }
  },
  methods: {
    checkDutyAndCarrierNo(val) {
      if(val == 'DDP') {
        this.incotermServices.push(this.incotermServiceId);
      } else {
        this.incotermServices.splice(this.incotermServices.indexOf(this.incotermServiceId), 1);
        this.$emit('input', {
          customsAddress: { ...this.value.customsAddress },
          customsAddressData: { ...this.value.customsAddressData },
          goods_incoterm: val,
          duty_paid_by: 1,
          duty_payer_account_no: this.value.duty_payer_account_no,
          freight_paid_by: this.value.freight_paid_by,
          freight_payer_account_no: this.value.freight_payer_account_no,
        });
      }
      this.$emit('incotermsServicesUpdate', this.incotermServices);
    },
    checkCarrierNo(val) {
      if(parseInt(val) !== 3) {
        this.$emit('input', {
          customsAddress: {
            address_1: '',
            address_2: '',
            country_id: '',
            post_code: '',
            city: '',
            state: '',
          },
          customsAddressData: {
            company: '',
            attention: '',
            email: '',
            reference: '',
            vat: '',
            phone: {
              number: '',
              country: '',
            },
          },
          goods_incoterm: this.value.goods_incoterm,
          duty_paid_by: val,
          duty_payer_account_no: '',
          freight_paid_by: this.value.freight_paid_by,
          freight_payer_account_no: this.value.freight_payer_account_no,
        });
      }
    },
    checkFreightandCustomerInfo(val) {
      if(parseInt(val) !== 2) {
        this.freightCarrierAccountNumber = '';
        this.$emit('input', {
          customsAddress: { ...this.value.customsAddress },
          customsAddressData: { ...this.value.customsAddressData },
          goods_incoterm: this.value.goods_incoterm,
          duty_paid_by: this.value.duty_paid_by,
          duty_payer_account_no: this.value.duty_payer_account_no,
          freight_paid_by: val,
          freight_payer_account_no: '',
        });
        this.incotermServices.splice(this.incotermServices.indexOf(this.reciverPayId), 1); // this.incotermServices(this.reciverPayId)
      }
      if(parseInt(val) === 2) {
        this.incotermServices.push(this.reciverPayId); //this.reciverPayId
      }
      this.$emit('incotermsServicesUpdate', this.incotermServices);
    },
    changeAddress(type, val) {
      this.$emit('input', {
        customsAddress: {
          address_1: val.address_1 || '',
          address_2: val.address_2 || '',
          country_id: val.country_id || '',
          post_code: val.post_code || '',
          city: val.city || '',
          state: val.state || '',
        },
        customsAddressData: {
          company: val.company_name || this.value.customsAddressData.company,
          attention: val.name || this.value.customsAddressData.attention,
          email: val.email || this.value.customsAddressData.email,
          vat: val.vat || this.value.customsAddressData.vat,
          reference: val.reference || this.value.customsAddressData.reference,
          phone: {
            number: val.phone || this.value.customsAddressData.phone.number,
            country: this.value.customsAddressData.phone.country,
          },
        },
        goods_incoterm: this.value.goods_incoterm,
        duty_paid_by: this.value.duty_paid_by,
        duty_payer_account_no: this.value.duty_payer_account_no,
        freight_paid_by: this.value.freight_paid_by,
        freight_payer_account_no: this.value.freight_payer_account_no,
      });
    },
  },
}
</script>
